import { Video, BarChart } from 'lucide-react'
interface MetricsCardsProps {
  totalViews: number
  avgEngagement: number
  avgCompletionRate: number
}
const MetricsCards = ({ totalViews, avgEngagement, avgCompletionRate }: MetricsCardsProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
      <div className="bg-[#AFEEF9] shadow-sm rounded-3xl rounded-bl-none p-5 h-[150px] card-hover border border-foreground/5">
        <div className="flex justify-between items-start">
          <div>
            <p className="text-sm font-medium text-black">{`Total Views`}</p>
            <h3 className="text-4xl font-light text-black">{totalViews.toLocaleString()}</h3>
          </div>
          <div className="stat-icon-circle bg-black/0 border-black text-black">
            <Video className="h-6 w-6" />
          </div>
        </div>
      </div>
      <div className="bg-[#A281ED] shadow-sm rounded-3xl rounded-bl-none p-5 h-[150px] card-hover border border-foreground/5">
        <div className="flex justify-between items-start">
          <div>
            <p className="text-sm font-medium text-black">{`Average Engagement`}</p>
            <h3 className="text-4xl font-light text-black">{`${avgEngagement.toFixed(1)}%`}</h3>
          </div>
          <div className="stat-icon-circle bg-foreground/0 border-black text-black">
            <BarChart className="h-6 w-6" />
          </div>
        </div>
      </div>
      <div className="bg-[#F4DB66] shadow-sm rounded-3xl rounded-bl-none p-5 h-[150px] card-hover border border-foreground/5">
        <div className="flex justify-between items-start">
          <div>
            <p className="text-sm font-medium text-black">{`Average Completion Rate`}</p>
            <h3 className="text-4xl font-light text-black">{`${avgCompletionRate.toFixed(1)}%`}</h3>
          </div>
          <div className="stat-icon-circle bg-foreground/0 border-black text-black">
            <BarChart className="h-6 w-6" />
          </div>
        </div>
      </div>
    </div>
  )
}
export default MetricsCards
